var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonUnmute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 62 62",
    style: {
      enableBackground: "new 0 0 62 62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#AB9834;}\r\n\t.st1{fill:#D2D2D2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31,62C13.9,62,0,48.1,0,31C0,13.9,13.9,0,31,0c17.1,0,31,13.9,31,31C62,48.1,48.1,62,31,62z M31,1 C14.5,1,1,14.5,1,31s13.5,30,30,30s30-13.5,30-30S47.5,1,31,1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.8,41.1c-0.1,0-0.2,0-0.3-0.1l-7.8-6.4h-5.2c-0.3,0-0.5-0.2-0.5-0.5v-6.5c0-0.3,0.2-0.5,0.5-0.5h5.4 l7.6-6.2c0.1-0.1,0.4-0.1,0.5-0.1c0.2,0.1,0.3,0.3,0.3,0.5v19.3c0,0.2-0.1,0.4-0.3,0.5C34.9,41.1,34.9,41.1,34.8,41.1z M22,33.6 h4.9c0.1,0,0.2,0,0.3,0.1l7.1,5.8V22.4L27.4,28c-0.1,0.1-0.2,0.1-0.3,0.1H22V33.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.7,35.1c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7c1.1-0.8,1.7-2,1.7-3.2c0-1.2-0.7-2.3-1.8-3.2 c-0.2-0.2-0.3-0.5-0.1-0.7c0.2-0.2,0.5-0.3,0.7-0.1c1.4,1,2.2,2.5,2.2,4c0,1.5-0.8,3-2.1,4C38.9,35.1,38.8,35.1,38.7,35.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonUnmute);
export default __webpack_public_path__ + "static/media/button_unmute.f5ca693c55e1695a4e11c29dea6b518a.svg";
export { ForwardRef as ReactComponent };